@import "../landingBreakpoints.css";

.link {
  --discord-brand: #5865f2;
  --discord-brand-hover: #4752c4;

  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 1.25rem;
  border: none;
  border-radius: var(--radius-md);
  background: var(--discord-brand);
  color: #fff;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
  text-decoration: none;
  box-shadow: 0 2px 8px rgb(88 101 242 / 35%);
  transition: background var(--transition-fast), box-shadow var(--transition-fast),
    transform var(--transition-fast);
}

.link:hover {
  background: var(--discord-brand-hover);
  color: #fff;
  box-shadow: 0 4px 12px rgb(88 101 242 / 45%);
  transform: translateY(-1px);
}

.icon {
  display: flex;
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
}

.icon svg {
  width: 100%;
  height: 100%;
}

.label {
  white-space: nowrap;
}

@media (--landing-short-landscape) {
  .link {
    box-sizing: border-box;
    height: 2.15rem;
    padding: 0 0.85rem;
    font-size: 0.85rem;
  }
}
